export default __webpack_public_path__ + "static/media/ai_virtual_services_select_room_fr.658d8968.png";